import { render, staticRenderFns } from "./newAnnounceList.vue?vue&type=template&id=fa1b49dc&scoped=true&"
import script from "./newAnnounceList.vue?vue&type=script&lang=js&"
export * from "./newAnnounceList.vue?vue&type=script&lang=js&"
import style0 from "./newAnnounceList.vue?vue&type=style&index=0&id=fa1b49dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1b49dc",
  null
  
)

export default component.exports